module.exports = __webpack_public_path__ + "static/media/gate.326a3feb.gif";